import { combineReducers } from 'redux';

// Front
import LayoutReducer from './layouts/reducer';

// Authentication
import LoginReducer from './auth/login/reducer';
import AccountReducer from './auth/register/reducer';
import ForgetPasswordReducer from './auth/forgetpwd/reducer';
import ProfileReducer from './auth/profile/reducer';
import UserReducer from './user/reducer';
import RoleReducer from './auth/roles/reducer';
import ScopeReducer from './auth/scopes/reducer';

// Establishment
import EstablishmentReducer from './establishment/reducer';
import EstablishmentTypeReducer from './establishmentType/reducer';
import HoldingReducer from './holding/reducer';
import MaintenanceCompanyReducer from './maintenanceCompany/reducer';
import CompanyReducer from './company/reducer';
import CostCenterReducer from './costCenter/reducer';
import ManagementReducer from './management/reducer';
import ManagementTeamReducer from './managementTeam/reducer';
import ManagementPositionReducer from './managementPosition/reducer';
import ProductiveCycleReducer from './productiveCycle/reducer';
import ProductiveCycleStageReducer from './productiveCycleStage/reducer';
import ProductiveCycleStageTemplateReducer from './productiveCycleStageTemplate/reducer';
import FeedingBargesReducer from './feedingBarges/reducer';
import CropTypeReducer from './cropType/reducer';
import ConsumptionSourceReducer from './consumptionSource/reducer';
import PowerGenerationSourceReducer from './powerGenerationSource/reducer';
import PowerGenerationRegisterStatusReducer from './powerGenerationRegisterStatus/reducer';
import PowerGenerationHourMeterReducer from './powerGenerationHourMeter/reducer';
import PowerGenerationMaintenanceReducer from './powerGenerationMaintenance/reducer';
import FuelTankReducer from './fuelTank/reducer';
import FuelTypeReducer from './fuelType/reducer';
import FeedingSiloReducer from './feedingSilo/reducer';
import FuelSupplyReducer from './fuelSupply/reducer';
import FuelSupplyTypeReducer from './fuelSupplyType/reducer';

import MaintenanceTypeReducer from './maintenanceType/reducer';
import MaintenanceStatusReducer from './maintenanceStatus/reducer';
import PersonReducer from './person/reducer';

// WaterRights
import WaterRightsReducer from './waterRights/reducer';
import CultivationUnitReducer from './cultivationUnit/reducer';
import MeasurementFrequencyReducer from './measurementFrequency/reducer';
import WaterRightPositionReducer from './waterRightPosition/reducer';
import ReportingFrequencyReducer from './reportingFrequency/reducer';
import ProcedureTypeReducer from './procedureType/reducer';
import ProcedureHistoryReducer from './procedureHistory/reducer';
import AssociatedDocumentReducer from './associatedDocument/reducer';
import DocumentTypeReducer from './documentType/reducer';
import DistanceUnitReducer from './distanceUnit/reducer';
import FlowRateUnitReducer from './flowRateUnit/reducer';
import WaterSourceReducer from './waterSource/reducer';
import WaterSourceTypeReducer from './waterSourceType/reducer';
import UtmZoneReducer from './utmZone/reducer';
import GeodeticDatumReducer from './geodeticDatum/reducer';
import InstallationLocationReducer from './installationLocation/reducer';
import RealEstateRegistryReducer from './realEstateRegistry/reducer';
import ReportingStatusReducer from './reportingStatus/reducer';
import RightExerciseTypeReducer from './rightExerciseType/reducer';
import WaterRightsStatusReducer from './waterRightsStatus/reducer';
import WaterRightTypeReducer from './waterRightType/reducer';
import WaterUseStatusReducer from './waterUseStatus/reducer';
import WaterUseTypeReducer from './waterUseType/reducer';
import WorkStatusReducer from './workStatus/reducer';
import WorkOrderStatusReducer from './workOrderStatus/reducer';
import WaterFlowRateListReducer from './waterFlowRateList/reducer';
import IntakeCoordinatesReducer from './intakeCoordinates/reducer';
import RestitutionCoordinatesReducer from './restitutionCoordinates/reducer';
import DistanceElevationReducer from './distanceElevation/reducer';
import ReportingTypeReducer from './reportingType/reducer';
import WorkOrderReducer from './workOrder/reducer';
import ScheduledActivityReducer from './scheduledActivity/reducer';
import MeasurementDetailReducer from './measurementDetail/reducer';

// Warehouse
import WarehouseReducer from './warehouse/reducer';
import WarehouseTransferReducer from './warehouseItemTransfer/reducer';
import WarehouseCategoryReducer from './warehouseCategory/reducer';
import WarehouseGroupReducer from './warehouseGroup/reducer';
import WarehouseItemReducer from './warehouseItem/reducer';
import WarehouseItemTransferReducer from './warehouseItemTransfer/reducer';
import PersonalProtectiveEquipmentReducer from './personalProtectiveEquipment/reducer';

// Calendar
import CalendarReducer from './calendar/reducer';

// Message
import MessageReducer from './message/reducer';
import NotificationReducer from './notification/reducer';

// Normative
import NormativeReducer from './normative/reducer';
import NormativeEstablishmentReducer from './normativeEstablishment/reducer';
import ObligationReducer from './obligation/reducer';
import ObligationEstablishmentReducer from './obligationEstablishment/reducer';
import ApplicationPhasesReducer from './applicationPhase/reducer';
import PeriodicitiesReducer from './periodicity/reducer';

// Residue
import ResidueReducer from './residue/reducer';
import ResidueTypeReducer from './residueType/reducer';
import ResidueDashboardReducer from './residueDashboard/reducer';
import GuideReducer from './guide/reducer';
import GuideDetailReducer from './guideDetail/reducer';
import ResidueTraceReducer from './residueTrace/reducer';
import ResidueCategoryReducer from './residueCategory/reducer';
import ResidueIntakeReducer from './residueIntake/reducer';
import WarehouseResidueStockReducer from './warehouseResidueStock/reducer';

// Destination
import FinalDestinationReducer from './finalDestination/reducer';
import AssignationManagementResidueFinalDestinationReducer from './assignationManagementResidueFinalDestination/reducer';

// Statement
import StatementReducer from './statement/reducer';

// Transfer
import TransferReducer from './transfer/reducer';
import TransferCompanyReducer from './transferCompany/reducer';
import TransferDriverReducer from './transferDriver/reducer';
import TransferTypeReducer from './transferType/reducer';

// File Manager
import FileManagerReducer from './fileManager/reducer';

// Settings
import SettingsReducer from './settings/reducer';
import PaymentReducer from './payment/reducer';

// Activity
import ActivityReducer from './activity/reducer';

// Screen
import ScreenReducer from './screen/reducer';
import FieldReducer from './field/reducer';
import ReportReducer from './report/reducer';

// Evidence
import EvidenceReducer from './evidence/reducer';

// Data Finance
import DataFinanceReducer from './dataFinance/reducer';

// Data Providers
import {
	OxygenProviderReducer,
	SaturationProviderReducer,
	SalinityProviderReducer,
	TemperatureProviderReducer,
	ChlorophyllProviderReducer,
	TurbidityProviderReducer,
	AllProviderReducer,
	MeasurementReducer,
	InformationRegisterSMAReducer,
} from './dataProviders/reducer';

import DataSpedReducer from './dataSped/reducer';

import DataWeatherReducer from './dataWeather/reducer';

import ArticleReducer from './article/reducer';

// Beach Cleaning
import BeachCleaningReducer from './beachCleaning/reducer';

// Residue Collected
import ResidueCollectedReducer from './residueCollected/reducer';

// Unit Measurement
import UnitMeasurementReducer from './unitMeasurement/reducer';

// ResidueConversion
import ResidueConversionReducer from './residueConversion/reducer';

// Establishment Assignation
import EstablishmentAssignationReducer from './establishmentAssignation/reducer';

// Fiscal Year
import FiscalYearReducer from './fiscalYear/reducer';

// Period
import PeriodReducer from './period/reducer';
import WarehouseGuideReducer from './warehouseGuide/reducer';
import PositionReducer from './position/reducer';
import InspectionTypeReducer from './inspectionType/reducer';
import InspectionAuthorityReducer from './inspectionAuthority/reducer';
import InspectionReducer from './inspection/reducer';
import BreachCategoryReducer from './breachCategory/reducer';
import BreachOriginReducer from './breachOrigin/reducer';
import BreachImpactReducer from './breachImpact/reducer';
import BreachResponsibleAreaReducer from './breachResponsibleArea/reducer';
import BreachRiskClassificationReducer from './breachRiskClassification/reducer';
import BreachTypeOfEvidenceReducer from './breachTypeOfEvidence/reducer';
import BreachRecordReducer from './breachRecord/reducer';
import BreachStatusReducer from './breachStatus/reducer';
import ActivityStatusReducer from './activityStatus/reducer';
import AuthorityStatusReducer from './authorityStatus/reducer';
import FiscalizerReducer from './fiscalizer/reducer';

const rootReducer = combineReducers({
	Layout: LayoutReducer,
	Login: LoginReducer,
	Account: AccountReducer,
	ForgetPassword: ForgetPasswordReducer,
	Profile: ProfileReducer,
	Users: UserReducer,
	Roles: RoleReducer,
	Scopes: ScopeReducer,
	Establishments: EstablishmentReducer,
	EstablishmentTypes: EstablishmentTypeReducer,
	Holdings: HoldingReducer,
	MaintenanceCompany: MaintenanceCompanyReducer,
	Companies: CompanyReducer,
	CostCenter: CostCenterReducer,
	Managements: ManagementReducer,
	ManagementTeams: ManagementTeamReducer,
	ManagementPositions: ManagementPositionReducer,
	Calendar: CalendarReducer,
	Normatives: NormativeReducer,
	Obligations: ObligationReducer,
	ObligationEstablishments: ObligationEstablishmentReducer,
	FinalDestinations: FinalDestinationReducer,
	ResidueTypes: ResidueTypeReducer,
	ResidueCategories: ResidueCategoryReducer,
	Residues: ResidueReducer,
	Guides: GuideReducer,
	GuideDetails: GuideDetailReducer,
	ResidueTrace: ResidueTraceReducer,
	ResidueIntakes: ResidueIntakeReducer,
	WarehouseResidueStock: WarehouseResidueStockReducer,
	Transfers: TransferReducer,
	TransferCompanies: TransferCompanyReducer,
	TransferDrivers: TransferDriverReducer,
	TransferType: TransferTypeReducer,
	FileManager: FileManagerReducer,
	NormativeEstablishments: NormativeEstablishmentReducer,
	AssignationManagementResidueFinalDestinations:
		AssignationManagementResidueFinalDestinationReducer,
	ResidueDashboard: ResidueDashboardReducer,
	Settings: SettingsReducer,
	Activities: ActivityReducer,
	Statements: StatementReducer,
	ApplicationPhases: ApplicationPhasesReducer,
	Periodicities: PeriodicitiesReducer,
	Warehouses: WarehouseReducer,
	WarehouseTransfers: WarehouseTransferReducer,
	WaterRights: WaterRightsReducer,
	CultivationUnit: CultivationUnitReducer,
	MeasurementFrequency: MeasurementFrequencyReducer,
	WaterRightPosition: WaterRightPositionReducer,
	ReportingFrequency: ReportingFrequencyReducer,
	ProcedureType: ProcedureTypeReducer,
	ProcedureHistory: ProcedureHistoryReducer,
	AssociatedDocument: AssociatedDocumentReducer,
	DocumentType: DocumentTypeReducer,
	DistanceUnit: DistanceUnitReducer,
	FlowRateUnit: FlowRateUnitReducer,
	WaterSource: WaterSourceReducer,
	WaterSourceType: WaterSourceTypeReducer,
	UtmZone: UtmZoneReducer,
	GeodeticDatum: GeodeticDatumReducer,
	InstallationLocation: InstallationLocationReducer,
	RealEstateRegistry: RealEstateRegistryReducer,
	ReportingStatus: ReportingStatusReducer,
	RightExerciseType: RightExerciseTypeReducer,
	WaterRightsStatus: WaterRightsStatusReducer,
	WaterRightType: WaterRightTypeReducer,
	WaterUseStatus: WaterUseStatusReducer,
	WaterUseType: WaterUseTypeReducer,
	WorkStatus: WorkStatusReducer,
	WorkOrderStatus: WorkOrderStatusReducer,
	WaterFlowRateList: WaterFlowRateListReducer,
	IntakeCoordinates: IntakeCoordinatesReducer,
	RestitutionCoordinates: RestitutionCoordinatesReducer,
	DistanceElevation: DistanceElevationReducer,
	ReportingType: ReportingTypeReducer,
	WorkOrder: WorkOrderReducer,
	ScheduledActivity: ScheduledActivityReducer,
	MeasurementDetail: MeasurementDetailReducer,
	WarehouseCategory: WarehouseCategoryReducer,
	WarehouseGroup: WarehouseGroupReducer,
	WarehouseItems: WarehouseItemReducer,
	WarehouseItemTransfers: WarehouseItemTransferReducer,
	ProductiveCycle: ProductiveCycleReducer,
	ProductiveCycleStage: ProductiveCycleStageReducer,
	ProductiveCycleStageTemplate: ProductiveCycleStageTemplateReducer,
	FeedingBarges: FeedingBargesReducer,
	CropType: CropTypeReducer,
	Evidences: EvidenceReducer,
	Screen: ScreenReducer,
	Field: FieldReducer,
	Report: ReportReducer,
	DataFinance: DataFinanceReducer,
	// DataProviders: DataProvidersReducer,
	DataSped: DataSpedReducer,
	DataWeather: DataWeatherReducer,
	Article: ArticleReducer,
	ConsumptionSource: ConsumptionSourceReducer,
	PowerGenerationSource: PowerGenerationSourceReducer,
	PowerGenerationRegisterStatus: PowerGenerationRegisterStatusReducer,
	PowerGenerationHourMeter: PowerGenerationHourMeterReducer,
	PowerGenerationMaintenance: PowerGenerationMaintenanceReducer,
	FuelTank: FuelTankReducer,
	FuelType: FuelTypeReducer,
	FeedingSilo: FeedingSiloReducer,
	FuelSupply: FuelSupplyReducer,
	FuelSupplyType: FuelSupplyTypeReducer,
	MaintenanceType: MaintenanceTypeReducer,
	MaintenanceStatus: MaintenanceStatusReducer,
	BeachCleanings: BeachCleaningReducer,
	ResidueCollecteds: ResidueCollectedReducer,
	UnitMeasurements: UnitMeasurementReducer,
	ResidueConversions: ResidueConversionReducer,
	EstablishmentAssignations: EstablishmentAssignationReducer,
	OxygenProvider: OxygenProviderReducer,
	TemperatureProvider: TemperatureProviderReducer,
	SaturationProvider: SaturationProviderReducer,
	SalinityProvider: SalinityProviderReducer,
	ChlorophyllProvider: ChlorophyllProviderReducer,
	TurbidityProvider: TurbidityProviderReducer,
	AllProvider: AllProviderReducer,
	Payments: PaymentReducer,
	Persons: PersonReducer,
	MeasurementProvider: MeasurementReducer,
	informationRegisterSMAProvider: InformationRegisterSMAReducer,
	Messages: MessageReducer,
	Notifications: NotificationReducer,
	PersonalProtectiveEquipments: PersonalProtectiveEquipmentReducer,
	FiscalYear: FiscalYearReducer,
	Period: PeriodReducer,
	WarehouseGuide: WarehouseGuideReducer,
	Positions: PositionReducer,
	InspectionType: InspectionTypeReducer,
	InspectionAuthority: InspectionAuthorityReducer,
	Inspection: InspectionReducer,
	BreachCategory: BreachCategoryReducer,
	BreachOrigin: BreachOriginReducer,
	BreachImpact: BreachImpactReducer,
	BreachResponsibleArea: BreachResponsibleAreaReducer,
	BreachRiskClassification: BreachRiskClassificationReducer,
	BreachTypeOfEvidence: BreachTypeOfEvidenceReducer,
	BreachRecord: BreachRecordReducer,
	BreachStatus: BreachStatusReducer,
	ActivityStatus: ActivityStatusReducer,
	AuthorityStatus: AuthorityStatusReducer,
	Fiscalizer: FiscalizerReducer,
});

export default rootReducer;
